/** Official IJF Kata Commission evaluation criteria used by practice judging. */
export const IJF_KATA_EVALUATION_SOURCE = {
  /** Exact document title / version label from the published PDF. */
  title: 'Kata competition criteria for the evaluation - 01.2025 - ENG',
  url: 'https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/up/2025/01/IJF_KATA_EVALUATION_Jan_2025-E-1737012784.pdf',
  fileName: 'IJF_KATA_EVALUATION_Jan_2025-E-1737012784.pdf',
} as const
